import * as React from 'react';

import { requestPut } from '../../../../modules/request/index';
import pusherInitializer from '../../../../modules/pusherInitializer'
import { ButtonSpinner, Checkbox } from '../../../Shared/index';
import useModalAccessibility from '../../../Shared/hooks/useModalAccessibility'

import { providerConfigLookup } from './providerHelpers'

const smallWhiteCheckSrc = `${window.postbuildEnv.CDN_URL}/images/shared/check-small-white.svg`

interface ImportProviderClassroomStudentsModalProps {
  classroom: any;
  close: () => void;
  onSuccess: (snackbarCopy: string) => void;
  provider: string
  user: any
}

const ImportProviderClassroomStudentsModal = ({ close, classroom, onSuccess, provider, user }: ImportProviderClassroomStudentsModalProps) => {
  const { modalRef, } = useModalAccessibility(close)

  const providerConfig = providerConfigLookup[provider]

  const [termsAccepted, setTermsAccepted] = React.useState(false);
  const [waiting, setWaiting] = React.useState(false);

  const handleImportStudents = () => {
    pusherInitializer(user.id, providerConfig.importStudentsEventName, () => onSuccess('Class re-synced'))
    setWaiting(true)
    requestPut(providerConfig.importStudentsPath, { classroom_id: classroom.id })
  }

  const handleToggleCheckbox = () => {
    setTermsAccepted(!termsAccepted)
  }

  const submitButtonClass = () => {
    const buttonClass = 'quill-button contained green medium focus-on-light';

    if (termsAccepted) { return buttonClass }

    return `${buttonClass} disabled`
  }

  const renderCheckboxes = () => {
    return (
      <div className="checkboxes">
        <div className="checkbox-row">
          <Checkbox
            label="I understand that newly imported students have access to the activities that have already been assigned to the entire class."
            onClick={handleToggleCheckbox}
            selected={termsAccepted}
          />
        </div>
      </div>
    )
  }

  const renderImportButton = () => {
    if (waiting) {
      return (
        <button className={submitButtonClass()} type="button">
          <ButtonSpinner />
        </button>
      )
    } else {
      return (
        <button className={submitButtonClass()} onClick={handleImportStudents} type="button">
          Import students
        </button>
      )
    }
  }

  return (
    <div className="modal-container import-provider-classroom-students-modal-container">
      <div className="modal-background" />
      <div
        aria-labelledby="importStudentsFromProviderModal"
        aria-modal={true}
        className="import-provider-classroom-students-modal quill-modal modal-body"
        ref={modalRef}
        role="dialog"
        tabIndex={-1}
      >
        <div>
          <h3 className="title" id="importStudentsFromProviderModal">Import students from {providerConfig.title}</h3>
        </div>
        <p>You are about to import students from the class {classroom.name}.</p>
        {renderCheckboxes()}
        <div className="form-buttons">
          <button className="quill-button outlined green medium focus-on-light" onClick={close} type="button">
          Cancel
          </button>
          {renderImportButton()}
        </div>
      </div>
    </div>
  )
}

export default ImportProviderClassroomStudentsModal
